exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-19c35614] .headSty{min-width:700px}.backAuth-content[data-v-19c35614]{color:#fff;margin-right:10px}.backAuth-content .backAuth[data-v-19c35614]{display:inline-block;padding:5px 10px;line-height:normal;border-radius:14px;cursor:pointer}.backAuth-content .backAuth[data-v-19c35614]:hover{background:hsla(0,0%,84.7%,.22)}", ""]);

// exports
